import React from 'react';
import GlobalStyle from '../styles/GlobalStyle';
import AgendaContextProvider from '../context/AgendaContext';
import { AuthenticatedTemplate, UnauthenticatedTemplate } from '@azure/msal-react';
import GenerateAgenda from '../components/GenerateAgenda';
import styled from 'styled-components';
import Menu from '../components/Menu';
import LogOutView from '../components/LogOutView';

const Container = styled.div`
    display: grid;
    grid-template-columns: 1fr 5fr; 
    position: relative; 
    height: 100%; 

    @media (max-width: 1150px) {
        grid-template-columns: 5rem 5fr; 
    }
`;

const AgendaGenerator = () => {
    return (
        <>
            <GlobalStyle />
            <AuthenticatedTemplate>
                <Container>
                    <div>
                        <Menu />
                    </div>
                    <AgendaContextProvider>
                        <GenerateAgenda />
                    </AgendaContextProvider>
                </Container>
            </AuthenticatedTemplate>
            <UnauthenticatedTemplate>
                <LogOutView />
            </UnauthenticatedTemplate>
        </>
    )
}

export default AgendaGenerator